// ============================================================================
// FORMATEO UNIVERSAL DE MONEDAS PARA LATINOAMÉRICA
// ============================================================================

// Mapeo de códigos de moneda a locales (para Intl.NumberFormat)
const CURRENCY_LOCALES: Record<string, string> = {
  USD: 'en-US',      // Dólar estadounidense
  EUR: 'es-ES',      // Euro
  VES: 'es-VE',      // Bolívar venezolano
  COP: 'es-CO',      // Peso colombiano
  ARS: 'es-AR',      // Peso argentino
  MXN: 'es-MX',      // Peso mexicano
  CLP: 'es-CL',      // Peso chileno
  PEN: 'es-PE',      // Sol peruano
  BRL: 'pt-BR',      // Real brasileño
};

/**
 * Formatea un valor numérico como moneda según el código ISO
 * Usa Intl.NumberFormat para manejar automáticamente:
 * - Símbolos de moneda correctos ($, S/, R$, etc)
 * - Separadores de miles (. vs ,)
 * - Decimales según país
 * - Posición del símbolo
 * 
 * @param value - Valor numérico a formatear
 * @param currency - Código ISO de moneda (USD, COP, ARS, etc)
 * @returns String formateado (ej: "$42.000", "S/ 37,50")
 */
export function formatCurrency(value: number, currency: string = 'USD'): string {
  const locale = CURRENCY_LOCALES[currency] || 'en-US';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

/**
 * Formatea una fecha según el locale español
 * (Mantener para compatibilidad con código existente)
 */
export function formatDate(value: string | Date): string {
  if (!value) return '';
  return new Intl.DateTimeFormat('es-AR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}
